import fetch, {postFrom, getBlob, getBlob2} from '../utils/fetch';

export function getBalanceListCondition() {
  return fetch({
    method: 'GET',
    url: '/proprietor/getBalanceListCondition'
  })
}

export function getBalanceList(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/getBalanceList',
    params
  })
}


export function balanceDetail(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/balanceDetail',
    params
  })
}


export function confirmBalance(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/confirmBalance',
    params
  })
}
// export function rejectBalance(params) {
//   return fetch({
//     method: 'POST',
//     url: '/proprietor/rejectBalance',
//     params
//   })
// }
export function auditRejectBalance(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/auditRejectBalance',
    params
  })
}

export function ownerRejectBalance(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/ownerRejectBalance',
    params
  })
}



export function passBalance(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/passBalance',
    params
  })
}


export function repay(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/repay',
    params
  })
}

export function releaseBalance(params) {
  return fetch({
    method: 'POST',
    url: '/proprietor/releaseBalance',
    params
  })
}


export function getBalanceOverview(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/getBalanceOverview',
    params
  })
}

export function exportBillDetailList(params) {
  return getBlob({
    method: 'POST',
    url: '/proprietor/exportBillDetailList',
    params
  })
}

export function canExportBalanceList(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/canExportBalanceList',
    params
  })
}

export function exportBalanceList(params) {
  return getBlob({
    method: 'GET',
    url: '/proprietor/exportBalanceList',
    params
  })
}
export function getBalanceReceiptDetail(params) {
  return fetch({
    method: 'GET',
    url: '/proprietor/getBalanceReceiptDetail',
    params
  })
}

